/**
 * @link https://span.studio
 * @copyright Copyright (c) Span Studio LLC
 * @license https://github.com/Span-Studio/sta100-craft5/blob/main/LICENSE.md
 * 
 * Select Toggle Data.
 * Updates select form fields based on selections.
 * 
 * @author John Pobojewski <https://john.pobojewski.com
 */

class SelectToggleData {

	init(c, nameVal, type) {
		console.log("SelectToggleData.init()");

		const selects = document.querySelectorAll(`select.${c}`);
		selects.forEach((select) => {
			select.addEventListener("change", function () {
				if (type === 'array') {
					const selectedValue = this.options[this.selectedIndex].value;
					this.name = selectedValue === "" ? nameVal : `${nameVal}[]`;
				}
			});
		});
	}
}

export default new SelectToggleData();
